/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormerCompanyWithOrigin
 */
export interface FormerCompanyWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof FormerCompanyWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof FormerCompanyWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the FormerCompanyWithOrigin interface.
 */
export function instanceOfFormerCompanyWithOrigin(value: object): value is FormerCompanyWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function FormerCompanyWithOriginFromJSON(json: any): FormerCompanyWithOrigin {
    return FormerCompanyWithOriginFromJSONTyped(json, false);
}

export function FormerCompanyWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormerCompanyWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function FormerCompanyWithOriginToJSON(value?: FormerCompanyWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

